import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CreateCvSectionSkillItemRequest,
  CvSectionSkill,
  CvSectionSkillItem,
  CvSectionSkillItemResponse,
  CvSectionSkillResponse,
} from '@/../gen';

export const namespace = 'cvSectionSkillItemNew';
const actionCreator = actionCreatorFactory(namespace);
export const GetCvSectionSkill = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_Skill');
export const SetCvSectionSkill = actionCreator<CvSectionSkillResponse>(
  'SET_CV_SECTION_Skill'
);
export const SetCvSectionSkillItem = actionCreator<CvSectionSkillItemResponse>(
  'SET_CV_SECTION_SKILL_ITEM'
);
export const CreateCvSectionSkillItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_skill_id: number;
  };
  body: CreateCvSectionSkillItemRequest;
}>('CREATE_CV_SECTION_SKILL_ITEM');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionSkill: CvSectionSkill;
  cvSectionSkillItem: CvSectionSkillItem;
}

const initialState = (): State => {
  return { cvSectionSkill: null, cvSectionSkillItem: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionSkill, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionSkill(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionSkill(data.data));
    }),
    action(CreateCvSectionSkillItem, async function(context, action) {
      const { data } = await this.proffApi.createCvSectionSkillItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_skill_id,
        action.payload.body
      );
      context.commit(SetCvSectionSkillItem(data.data));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionSkill, (state, action) => {
      state.cvSectionSkill = action.payload?.attributes;
    }),
    mutation(SetCvSectionSkillItem, (state, action) => {
      state.cvSectionSkillItem = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionSkill: state => state.cvSectionSkill,
    cvSectionSkillItem: state => state.cvSectionSkillItem,
  },
};
